import { NotificationPlacement } from 'antd/es/notification/interface';
import { createContext } from 'react';

export type ToastOptions = {
  title: string;
  description: string;
  type: 'Light' | 'Danger' | 'Success' | 'Warning' | 'Info';
  duration?: number;
  onClick?: () => void;
};

type NotificationsContextProps = {
  openNotification: (placement: NotificationPlacement, data: ToastOptions) => void;
  closeNotification: () => void;
};

const initNotificationsContextPropsState = {
  closeNotification: () => {},
  showNotification: () => {},
  hideNotification: () => {},
  setOptions: () => {},
  openNotification: () => {},
};

const NotificationsContext = createContext<NotificationsContextProps>(initNotificationsContextPropsState);
NotificationsContext.displayName = 'Notifications';

export default NotificationsContext;
